export class PageConfig {
	pageViewes: PageViewModel[] = [
		{
			route: 'job',
			display: 'Job Dashboard',
			showSearch: false,
			customDisplay: true,
			addLink: '',
		},
		{
			route: 'job/complete',
			display: 'Completed Jobs',
			showSearch: false,
			customDisplay: true,
			addLink: '',
		},
		{
			route: 'company',
			entity: 'Company',
			display: 'Companies',
			showSearch: true,
			customDisplay: false,
			addLink: '/company/add',
		},
		{
			route: 'comment',
			entity: 'Comment',
			display: 'Comments',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'channel',
			entity: 'Channel',
			display: 'Channels',
			showSearch: true,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'district',
			entity: 'District',
			display: 'Districts',
			showSearch: true,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'unit-config',
			entity: 'Unit Configuration',
			display: 'Unit',
			showSearch: true,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'output-config',
			entity: 'Output Configuration',
			display: 'Unit',
			showSearch: true,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'asset/unit',
			entity: 'Unit',
			display: 'Assets',
			showSearch: true,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'asset/unit/edit',
			entity: 'Edit Unit',
			display: 'Edit Unit',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'asset/string',
			entity: 'String',
			display: 'Assets',
			showSearch: true,
			customDisplay: false,
			addLink: '/asset/string/add',
		},
		{
			route: 'asset/reel',
			entity: 'Reel',
			display: 'Assets',
			showSearch: true,
			customDisplay: false,
			addLink: '/asset/reel/add',
		},
		{
			route: 'asset/bop',
			entity: 'BOP',
			display: 'Assets',
			showSearch: true,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'asset/device',
			entity: 'Device',
			display: 'Assets',
			showSearch: true,
			customDisplay: false,
			addLink: '/asset/device/add',
		},
		{
			route: 'user',
			entity: 'User',
			display: 'Users',
			showSearch: true,
			customDisplay: false,
			addLink: '/user/add',
		},
		{
			route: 'download',
			entity: 'Download',
			display: 'Downloads',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'version',
			entity: 'Version',
			display: 'Versions',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'error-page',
			entity: 'Error',
			display: 'Error',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'unit-of-measure',
			entity: 'Unit of Measure',
			display: 'Units of Measure',
			showSearch: true,
			customDisplay: false,
			addLink: '/unit-of-measure/add',
		},
		{
			route: 'unit',
			entity: 'Unit',
			display: 'Units',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
		{
			route: 'unit/edit',
			entity: 'Edit Unit',
			display: 'Edit Unit',
			showSearch: false,
			customDisplay: false,
			addLink: '',
		},
	];

	get pageViews(): any {
		return this.pageViewes;
	}
}

export class PageViewModel {
	route: string;
	entity?: string;
	display: string;
	showSearch: boolean;
	customDisplay: boolean;
	addLink: string;
}
